// import './clock';
// import './carousel';
import './menu';
import './woo';
import './posts/loadmore';
import './scripts'; // Import generic scripts

// Styles
import '../sass/main.scss';

// Images
import '../img/patterns/bg.jpeg';
import '../img/patterns/c1-150x150.jpeg';
import '../img/patterns/c2-150x150.jpeg';
import '../img/patterns/c3-150x150.jpeg';
import '../img/email.webp';
import '../img/payment.webp';
import '../img/secure-with-macfee.webp';

jQuery(document).ready(function($) {
  // Product category menu open when click on it - Start
  $('.account-link-main .menu-item-account').hover(
    function () {
      $('.asgard-account-menu, .asgard-account-signin').addClass('d-block visible');
      $('.asgard-account-menu, .asgard-account-signin').removeClass('d-none invisible');
    },
    function () {
      $('.asgard-account-menu, .asgard-account-signin').removeClass('d-block visible');
      $('.asgard-account-menu, .asgard-account-signin').addClass('d-none invisible');
    }
  );
  $('.asgard-account-menu, .asgard-account-signin').hover(
    function () {
      $(this).addClass('d-block visible');
      $(this).removeClass('d-none invisible');
    },
    function () {
      $(this).removeClass('d-block visible');
      $(this).addClass('d-none invisible');
    }
  );

  // Mega menu hover handlers
  let megaMenuTimeout;
  
  // Show menu when hovering over the button
  $('.mega-menu-title').on('mouseenter', function() {
    clearTimeout(megaMenuTimeout);
    $('#mega_menu_block').stop(true, true).removeClass('d-none invisible').addClass('d-block visible');
  });
  
  $('.mega-menu-title').on('mouseleave', function() {
    megaMenuTimeout = setTimeout(function() {
      if (!$('#mega_menu_block').is(':hover')) {
        $('#mega_menu_block').removeClass('d-block visible').addClass('d-none invisible');
      }
    }, 200);
  });
  
  // Keep menu visible when hovering over it
  $('#mega_menu_block').on('mouseenter', function() {
    clearTimeout(megaMenuTimeout);
    $(this).stop(true, true).removeClass('d-none invisible').addClass('d-block visible');
  });
  
  $('#mega_menu_block').on('mouseleave', function() {
    megaMenuTimeout = setTimeout(function() {
      $('#mega_menu_block').removeClass('d-block visible').addClass('d-none invisible');
    }, 200);
  });

  // Call headerAffix initially
  headerAffix();

  // Call headerAffix on scroll
  $(window).on("scroll", function (event) {
    headerAffix();
  });

  function headerAffix() {
    var scrollValue = $(window).scrollTop();
    var middleBarHeight = $(".middle-bar").height();

    if (scrollValue > middleBarHeight) {
      $("body").addClass("fixed");
    } else {
      $("body").removeClass("fixed");
    }
  }

  $('.single-last-related .blog-main').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $(".medi-switch-to-register").click(function() {
    $(".customer-account-main").toggleClass("register-active");
    var currentText = $(this).text();
    var newText = currentText === "Login" ? "Register" : "Login";
    $(this).text(newText);
  });
});